import { path } from "routes/constant";

const config = {
  // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
  // like '/berry-material-react/react/default'
  basename: "/",
  defaultPath: path.FINANCIAL_FORECAST_FREECASH_FLOW,
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 6,
  apiURL: "https://plansas-test-https.eastus.azurecontainer.io",
  inputStyle: { padding: "5px 12px" },
  colorInputStyle: { padding: "6px 0px" },
  colorInputWrapperStyle: { width: 140, padding: "6px 12px" },
};

export default config;
